module.exports = function(obj){
var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
with(obj||{}){
__p+='<img class="img-responsive" src="' + require("C:\\dev\\RNS2\\ReviewAndSignUi\\node_modules\\underscore-template-loader\\file-loader.js?url=..%2F..%2F..%2Fimages%2Fhelp%2Fcorporate.jpg!../../../images/help/corporate.jpg") + '"/>';
}
return __p;
};



//////////////////
// WEBPACK FOOTER
// ./app/templates/help/help-corporate-admin-view.html
// module id = 509
// module chunks = 0